import React, {useEffect} from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import TimerIcon from '@material-ui/icons/Timer';
import {convertISODateTimeToHHmmBRLocale, convertSecondsToMinutesSecondsFormat} from "./Util";
import {useDispatch, useSelector} from "react-redux";
import {renderMilisecondsToTimeDuration} from "../utils/datetimehelp";
import {getColorForPercentage} from "../utils/utils";
import {getEstacoesTrabalho} from "../actions/i4Actions";

const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 3,
        backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
     //   borderRadius: '15px',
     //   minHeight: '150px',
     //   marginBottom:'30px',
        // width: '120px'

    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        // alignSelf: 'stretch',
    },

    nomeEtapa: {
        //backgroundColor: 'red',
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'center',
        borderBottom: '1px solid red'
    },
    valoresArea: {
      //  backgroundColor: 'green'
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',

    },
    fila: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    concluidos: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    tempomedio: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignSelf: 'center',
        fontSize:'2rem'
    },
    tempoLabel: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'flex-end',
        paddingTop: '2px'
    },
    tempoValor: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly'

    },
    operadores: {
        display: 'flex',
        flexDirection: 'row',
        flexwrap: 'wrap',
        justifyItems: 'center',
        justifyContent: 'space-evenly'

    },
    estacao: {
        marginBottom: '4px'
    }


}));

const OperadoresNaLinhaGrid = () => {

    const classes= useStyles();
    const estacoesTrabalho = useSelector(state => state.i4.estacoesTrabalho );
    const loginLogoutsHoje = useSelector(state => state.i4.loginLogoutsHoje );
    const processos = useSelector(state => state.i4.processos );
    const ixProcessoPadrao = processos.findIndex(p => p.id === 1);
    const dispatch = useDispatch();



    useEffect(()=>{
        //  getPage()
        const interval=setInterval(()=>{
            dispatch(getEstacoesTrabalho());;
        },5000);
        return()=>clearInterval(interval)
    },[estacoesTrabalho])






        return (
            <Grid id="operadoresGridExt" item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid id="operadoresMainGrid" container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid item className={classes.nomeEtapa} xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant="h4">OPERADORES</Typography>
                        </Grid>
                        <Grid item container className={classes.operadores} xs={12} sm={12} lg={12} xl={12}>
                            { estacoesTrabalho
                                .filter(o => o.operadorId !== 0 && o.operadorId !== null)
                                .map( (o,ix) => {
                                            let pe;
                                            let styleGradiente = {}
                                            let perc = 0;

                                    let tempoSec;


                                    if (o.OSAtual !== '0' && processos.length>0) {
                                        console.log("processos", processos)
                                        pe = processos[ixProcessoPadrao].processoEtapas.find(pe => pe.etapaId === o.etapaId);

                                        tempoSec = (new Date().getTime() - new Date(o.OSDhIni).getTime()) / 1000;

                                        if (pe && tempoSec) {
                                            if (tempoSec < pe.tempoReferenciaMinimoSec) {
                                                styleGradiente = { backgroundColor: 'yellow'};
                                            }
                                            if (tempoSec >= pe.tempoReferenciaMinimoSec &&
                                                tempoSec <= pe.tempoReferenciaMaximoSec) {
                                                perc = (1 - ((tempoSec - pe.tempoReferenciaMinimoSec) /
                                                    (pe.tempoReferenciaMaximoSec - pe.tempoReferenciaMinimoSec)));
                                                styleGradiente = { backgroundColor: getColorForPercentage(perc) };
                                                styleGradiente = { backgroundColor: 'green'};

                                            }
                                            if (tempoSec > pe.tempoReferenciaMaximoSec) {
                                                styleGradiente = { backgroundColor: 'red'};
                                            }

                                        }
                                    }

                                console.log("estacao", o, tempoSec, styleGradiente, pe);

                                return (
                                    <Grid item container className={classes.estacao} style={{...styleGradiente}}  key={ix} xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                            <Typography key={ix}  >{o.descricao} </Typography>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <Typography key={ix} >{o.operador.nome} ({o.operadorId}) </Typography>
                                        </Grid>
                                        <Grid item xs={4} sm={3} md={3} lg={3} xl={3}>
                                            <Typography key={ix} >{o.OSAtual !== '0' ? o.OSAtual : '--'} </Typography>
                                        </Grid>
                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                            <Typography key={ix} >{o.OSAtual !== '0' ? renderMilisecondsToTimeDuration(new Date().getTime() - new Date(o.OSDhIni).getTime()) : '--' } </Typography>
                                        </Grid>
                                    </Grid>
                                )
                            })}
                        </Grid>

                </Grid>
                <Grid id="operadoresMainGrid" container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid item className={classes.nomeEtapa} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h4">LOGINS-LOGOUTS</Typography>
                    </Grid>
                    <Grid item container className={classes.operadores} xs={12} sm={12} lg={12} xl={12}>
                        {
                            loginLogoutsHoje
                                .map( (llh,ix) => {
                                   return (
                                       <Grid item container className={classes.estacao} style={{ display: 'flex', justifyContent: `space-between` }}  key={ix} xs={12} sm={12} md={12} lg={12} xl={12}>
                                           <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                               <Typography key={ix}  >{llh.operadorId} </Typography>
                                           </Grid>
                                           <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                               <Typography key={ix} >{convertISODateTimeToHHmmBRLocale(llh.dt)} </Typography>
                                           </Grid>
                                           <Grid item xs={4} sm={3} md={3} lg={3} xl={3}>
                                               <Typography key={ix} >{convertISODateTimeToHHmmBRLocale(llh.dtLogout)}</Typography>
                                           </Grid>
                                       </Grid>
                                   );
                                })
                        }
                    </Grid>
                </Grid>
            </Grid>
        )
    }

export default OperadoresNaLinhaGrid;


